import { render, staticRenderFns } from "./RecommendationBlock.vue?vue&type=template&id=39f88926&scoped=true&"
import script from "./RecommendationBlock.vue?vue&type=script&lang=js&"
export * from "./RecommendationBlock.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationBlock.vue?vue&type=style&index=0&id=39f88926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f88926",
  null
  
)

export default component.exports